<template>
  <div id="lavori">
    <h1 class="font-weight-light w3-serif ml-12">
      I nostri lavori
    </h1>
    <br>

    <!-- https://getbootstrap.com/docs/5.0/components/modal/ -->
    <div v-for="work in works" :key="work.id" class="modal fade" :id="work.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered"  role="document">
        <div class="modal-content works-modal-content-none-border">
          <div class="modal-body p-0">
            <div class="text-center">
              <img class="img-fluid rounded" :src="work.src">
              <div style="background-color: black !important;">
                  <p class="text-white mb-0">{{work.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- https://getbootstrap.com/docs/5.0/components/carousel/ -->
    <!-- https://mdbootstrap.com/snippets/jquery/ascensus/135508#html-tab-view -->

    <div v-if="$isMobile()">
      <div id="carouselExampleCaptions" class="carousel slide mb-16" data-ride="carousel">
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
        <div class="carousel-inner" role="listbox">
          <div v-for="work in works" :key="work.id" :class="work.mobileCarouselItem"> 
            <div class="col-ms-12">
              <img class="card-img-top" :src="work.src" data-bs-toggle="modal" :data-bs-target="'#'+work.id">
              <!-- <div class="carousel-caption">
                <p>{{work.description}}</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div id="carouselExampleCaptions" class="carousel slide mb-16 ml-8 mr-8" data-ride="carousel">
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
        <div class="carousel-inner" role="listbox">
          <div class="carousel-item active">    
            <div class="row">
              <div class="col-md-4">
                <img class="card-img-top works-carousel-img" :src="works.firstWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.firstWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.secondWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.secondWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.thirdWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.thirdWork.id">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="col-md-4">
                <img class="card-img-top works-carousel-img" :src="works.fourthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.fourthWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.fivethWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.fivethWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.sixthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.sixthWork.id">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="col-md-4">
                <img class="card-img-top works-carousel-img" :src="works.seventhWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.seventhWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.eighthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.eighthWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.ninthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.ninthWork.id">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="col-md-4">
                <img class="card-img-top works-carousel-img" :src="works.tenthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.tenthWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.eleventhWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.eleventhWork.id">
              </div>
              <div class="col-md-4 clearfix d-none d-md-block">
                <img class="card-img-top works-carousel-img" :src="works.twelfthWork.src" data-bs-toggle="modal" :data-bs-target="'#'+works.twelfthWork.id">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Lavori',
    data: () => ({
      works:{
        firstWork:{
          id: "firstWork",
          src: require("../assets/primoLavoro.jpg"),
          description: "Ristrutturazione e risanamento conservativo della Banca di Credito Cooperativo - Recanati",
          mobileCarouselItem: "carousel-item active",
        },
        secondWork:{
          id: "secondWork",
          src: require("../assets/secondoLavoro.jpg"),
          description: "Centro studi",
          mobileCarouselItem: "carousel-item",
        },
        thirdWork:{
          id: "thirdWork",
          src: require("../assets/terzoLavoro.jpg"),
          description: "Risanamento immobile - Recanati - Piazzale Monaldo Leopardi",
          mobileCarouselItem: "carousel-item",
        },
        fourthWork:{
          id: "fourthWork",
          src: require("../assets/quartoLavoro.jpg"),
          description: "Convento frati cappuccini - Recanati", 
          mobileCarouselItem: "carousel-item",
        },
        fivethWork:{
          id: "fivethWork",
          src: require("../assets/quintoLavoro.jpg"),
          description: "Muro di cinta frati cappuccini - Recanati",
          mobileCarouselItem: "carousel-item",
        },
        sixthWork:{
          id: "sixthWork",
          src: require("../assets/sestoLavoro.jpg"),
          description: "Nuove costruzioni",
          mobileCarouselItem: "carousel-item",
        },
        seventhWork:{
          id: "seventhWork",
          src: require("../assets/settimoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Facciata",
          mobileCarouselItem: "carousel-item",
        },
        eighthWork:{
          id: "eighthWork",
          src: require("../assets/ottavoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Ingresso Laterale",
          mobileCarouselItem: "carousel-item",
        },
        ninthWork:{
          id: "ninthWork",
          src: require("../assets/nonoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Interno",
          mobileCarouselItem: "carousel-item",
        },
        tenthWork:{
          id: "tenthWork",
          src: require("../assets/decimoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Interno Laterale",
          mobileCarouselItem: "carousel-item",
        },
        eleventhWork:{
          id: "eleventhWork",
          src: require("../assets/undicesimoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Altare",
          mobileCarouselItem: "carousel-item",
        },
        twelfthWork:{
          id: "twelfthWork",
          src: require("../assets/dodicesimoLavoro.jpg"),
          description: "Ristrutturazione Chiesa dei Frati Minori Cappuccini di Recanati - Dettaglio: Interno(2)",
          mobileCarouselItem: "carousel-item",
        },
      }
    }),
  }
</script>

<style>
.carousel-control-next, .carousel-control-prev {
  width: 5%;
}
.works-modal-content-none-border{
  border-style: none;
}
.works-carousel-img{
  cursor: zoom-in;
}
</style>